module.exports = __webpack_public_path__ + "img/arrow-square-right.cef09a21.svg";